import React from 'react';
import styled from 'styled-components';
import moment from 'moment';
import { palette } from '../../../../system/styles/styles';
import { useTranslation } from 'react-i18next';
import { Tooltip } from '@material-ui/core';
import { NotificationManager } from 'react-notifications';
import { useDispatch, useSelector } from 'react-redux';
import { MailSend, Copy, Save, CaretUp, CaretDown, MoveHorizontal } from 'styled-icons/boxicons-regular';
import { Whatsapp } from 'styled-icons/boxicons-logos';
import { DocumentDelete } from 'styled-icons/typicons';
import { sendActivity } from '../../../../redux/actions/backendActions';

const MainContainer = styled.main`
  margin-top: 24px;
  height: calc(100vh - 190px);
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 0.5em;
    height: 0.5em;
  }

  &::-webkit-scrollbar-track {
    background-color: #f2f2f2;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #ccc;
    border-radius: 0.5rem;
  }

  a {
    border-radius: 4px;
    border: none;
    padding: 10px 15px;
    color: ${palette.black};
    margin: auto;
    font: inherit;
    background-color: rgb(239, 239, 239);
    text-decoration: none;
  }

  label {
    font-size: 16px;
  }

  p {
    font-size: 14px;
  }
  nav {
    width: 100%;
    display: flex;
    justify-content: flex-start;

    button {
      background-color: transparent;
      color: ${palette.black};
      font-size: 1rem;
      text-transform: uppercase;
      border-radius: 0;
      min-width: 30%;
      border: none;
    }
    .selected {
      transition: all 30ms;
      border-radius: 0;
      border-bottom: solid 2px ${palette.blue};
    }
  }

  table {
    width: 95%;
    margin: 20px auto;
    tr {
      color: white;
      text-align: center;
      display: grid;
      grid-template-columns: 3fr 1fr 1fr 1fr;
      th {
        padding: 10px 0px;
        background-color: rgb(97, 149, 141);
      }
      td {
        display: flex;
        font-size: 0.75rem;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        img {
          width: 14px;
          height: 14px;
          margin-left: 5px;
        }
        p {
          font-size: 0.75rem;
          width: 100%;
          padding: 0;
          text-align: start;
          font-weight: 600;
        }
      }
    }
    .shadowCell {
      color: ${palette.black};
      background-color: rgb(229, 231, 234);
      padding: 5px;
    }
    .whiteCell {
      color: ${palette.black};
      background-color: ${palette.white};
      padding: 5px;
    }
  }

  .general {
    padding: 24px;
    box-shadow: ${palette.lightBS};
    display: flex;
    flex-direction: column;
    width: 90%;
    border-radius: 10px;
    //background-color: red;
    margin: auto;
    .originCandidate {
      text-transform: capitalize;
    }
  }

  .box_file {
    margin-top: 30px;
    padding: 24px;
    //box-shadow: ${palette.lightBS};
    display: grid;
    //flex-direction: column;
    grid-gap: 10px;
    grid-template-columns: repeat(5, 1fr);

    .box_icon_file {
      padding: 24px;
      height: 15vh;
      //background-color: ${palette.grayNew} ;
    }

    label {
      text-align: left;
    }
  }

  .actions {
    margin-top: 30px;
    padding: 24px;
    box-shadow: ${palette.lightBS};
    display: flex;
    flex-direction: column;

    label {
      text-align: center;
      margin: 10px;
    }

    .toggle-button {
      display: block;
      width: 100%;
      background-color: transparent;
      font-size: 1.1rem;
      color: ${palette.purple};
      font-weight: 500;
      padding: 20px 0px;
    }

    section {
      width: 100%;
      padding: 5px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
    }
  }

  .nps {
    margin-top: 30px;
    padding: 24px;
    box-shadow: ${palette.lightBS};
    display: flex;
    flex-direction: column;

    table {
      tr {
        grid-template-columns: 3fr 1fr 1fr;
      }
    }

    label {
      text-align: left;
    }

    .toggle-button {
      display: block;
      width: 100%;
      background-color: transparent;
      font-size: 1.1rem;
      color: ${palette.purple};
      font-weight: 500;
      padding: 20px 0px;
    }

    section {
      width: 100%;
      padding: 5px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
    }
  }

  .inline-actions {
    margin: auto;

    button {
      margin: 0 10px !important;
      background-color: transparent;
      transition: 0.3s;
      cursor: pointer;
      border: none;

      &:hover {
        transition: 0.3s;
        box-shadow: ${palette.lightBS};
      }

      &:focus {
        outline: none;
      }
    }

    a {
      background-color: transparent;
    }
  }

  .inline {
    display: inline-flex;

    p {
      margin: 2px 10px;
      font-size: 14px;
      font-weight: 300;
    }

    label {
      margin: 2px 10px;
      font-size: 16px;
      font-weight: 400;
    }
  }

  .rows {
    margin-top: 20px;
    display: grid;
    grid-template-columns: 1fr;
  }

  .rows_applicants {
    width: 70%;
    margin: auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100px;
    box-shadow: ${palette.BSnewCard};
    border-radius: 8px;
    cursor: pointer;

    &:hover {
      border: 1px solid #ccc;
      box-shadow: ${palette.BSnewCard};
    }
  }

  .rows_applicants p {
    text-align: center;
  }

  .rows_applicants img {
    width: 50px;
    margin: auto;
  }

  .columns {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-column-gap: 1rem;
  }

  @media screen and (max-width: 1920px) {
    .box_file {
      grid-template-columns: repeat(4, 1fr);

      .box_icon_file {
        height: 20vh;
      }
    }
  }
  @media screen and (max-width: 1366px) {
    .box_file {
      grid-template-columns: repeat(3, 1fr);

      .box_icon_file {
        height: 20vh;
      }
    }
  }
`;

const GeneralStep = (props) => {
  const { time, longDescription, email, onClick, phoneNumber, names, lastNames, companyName, typeUser } = props;
  const { t } = useTranslation(['applicant']);
  const id = useSelector((state) => state.auth.uid);
  const vacancy = useSelector((state) => state.vacancy);
  const jobs = useSelector((state) => state.jobs);
  const dispatch = useDispatch();

  return (
    <MainContainer>
      <div className="general">
        <div className="inline">
          <label>{t('AppliedOn')} </label>
          <p>{moment(time).locale('es').format('L')}</p>
        </div>
        <div className="inline">
          <label>{t('Email')}</label>
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(2, 1fr)',
              gridRowGap: '1rem',
            }}>
            <p id="textcopy">{email}</p>
          </div>
        </div>
        {/*<div className="inline" style={{ display: 'inline-block' }}>*/}
        {/*  <label>{t('Description')}</label>*/}
        {/*  <p>{longDescription !== '' ? longDescription : t('ApplicantDidNotComment')}</p>*/}
        {/*</div>*/}
      </div>

      <div className="actions">
        <label>{t('SingleActions')}</label>
        <div className="inline-actions">
          <Tooltip title={t('tooltipCopyEmail')} arrow placement="top">
            <button
              type="button"
              onClick={() => {
                const textField = document.createElement('textarea');
                textField.innerText = email;
                const parentElement = document.getElementById('textcopy');
                parentElement.appendChild(textField);
                textField.select();
                document.execCommand('copy');
                parentElement.removeChild(textField);
                NotificationManager.success(t('EmailCopied'), '', 3000);
              }}>
              <Copy size={40} color={palette.purple} />
            </button>
          </Tooltip>
          {phoneNumber ? (
            <Tooltip title={t('tooltipSendWhats')} arrow placement="top">
              <button
                type="button"
                onClick={() => {
                  const mensaje = `¡Hola ${names} ${lastNames}, buen día! Me gustaría contactarte para platicar sobre una vacante y estamos en búsqueda de perfiles rockstars como el tuyo!`;
                  window.open(`https://api.whatsapp.com/send?phone=${phoneNumber}&text= ${mensaje} `, 'lapieza.io');
                }}>
                <Whatsapp size={40} color={palette.purple} />
              </button>
            </Tooltip>
          ) : null}

          {/*<Tooltip title={t('tooltipReject')} arrow placement="top">*/}
          {/*    <button type="button" onClick={() => setOpenModalRejected(true)}>*/}
          {/*        <DeleteOutline size={40} color={palette.purple} />*/}
          {/*    </button>*/}
          {/*</Tooltip>*/}

          {/*<Popup*/}
          {/*    anchor={moveRef}*/}
          {/*    show={expanded}*/}
          {/*    popupClass="popup-content"*/}
          {/*    style={{*/}
          {/*        zIndex: 1300,*/}
          {/*    }}*/}
          {/*    popupAlign={{*/}
          {/*        horizontal: 'center',*/}
          {/*        vertical: 'top',*/}
          {/*    }}*/}
          {/*    anchorAlign={{*/}
          {/*        horizontal: 'center',*/}
          {/*        vertical: 'bottom',*/}
          {/*    }}*/}
          {/*>*/}
          {/*    <PopupMove onClose={onClose} expanded={expanded} />*/}
          {/*</Popup>*/}
        </div>
      </div>
    </MainContainer>
  );
};

export default GeneralStep;
